export default __webpack_public_path__ + "static/articulo2-91e876e147ef18961ef59dcc086bd89a.png";